// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1WvEP","header":"MergedInvoice_header__129LD"};